<template>
  <div>
    <b-row v-if="showFilters" class="pt-2 pb-1">
      <b-col cols="6" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
    </b-row>

    <!-- Table Container Card -->
    <CompositeAlarmRuleComponent
      ref="refListTable"
      :currentPage="currentPage"
      :dataMeta="dataMeta"
      :fetchList="fetchList"
      :isSortDirDesc="isSortDirDesc"
      :perPage="perPage"
      :perPageOptions="perPageOptions"
      :showFilters="showFilters"
      :searchQuery="searchQuery"
      :sortBy="sortBy"
      :tableColumns="tableColumns"
      :totalList="totalList"
      :search-query.sync="searchQuery"
      @per-page="perPageValue"
      @update="update"
      @refresh-data="refreshData"
    />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
  BInputGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import useList from "./useList";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import Pagination from "@/components/Pagination.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import FiltersComponent from "../components/FiltersComponent";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import CompositeAlarmRuleComponent from "../dmp_composite_alarm_rules/components/CompositeAlarmRuleTable.vue";

export default {
  components: {
    Pagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    vSelect,
    ToastificationContent,
    BreadcrumbMenu,
    FiltersComponent,
    ButtonFilters,
    FilterModal,
    CompositeAlarmRuleComponent,
  },
  props: {
    showFilters:{
      type: Boolean,
      default: true
    }
  },
  setup(_, context) {
    //start pagination
    const perPageValue = (data) => {
      perPage.value = data;
    };

    const update = (data) => {
      currentPage.value = data;
    };
    //end pagination

    const { t } = useI18nUtils();

    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      clearSearchFilters,
      buildFilters,
      filtersCount,
      idDmpProfile,
      eventCode,
      typeAlarm,
    } = useList();

    const itemFilter = ref();

    const addItemFilter = (data) => {
      itemFilter.value = data;
    };
    const addItemFilterSearch = (data) => {
      data.forEach((element) => {
        if (nameNav.value === element.text) {
          searchQuery.value = element.searchQuery;
        }
      });
    };
    const nameNav = ref("breadcrumbs.iot.dmp.alarms");

    // On Click the refresh button
    const refreshData = () => refetchData();

    return {
      nameNav,
      addItemFilter,
      itemFilter,
      addItemFilterSearch,

      update,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,

      clearSearchFilters,
      buildFilters,
      filtersCount,

      idDmpProfile,
      eventCode,
      typeAlarm,

      perPageValue,
      refreshData,
    };
  },
};
</script>